<template>
  <el-popover placement="right" trigger="click" width="250" v-model="show">
    <div class="medication-info">
      <p>
        <strong>眼别：</strong>
        <el-select size="mini" v-model="model.CHPLeftRightEyes" placeholder="请选择眼别" style="width: 150px;"
          @change="handleChange($event, 'eye')">
          <el-option v-for="item in eye2SelectOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
      <p><strong>处方：</strong>
        <el-select size="mini" v-model="model.CHPS_OP_ALL_Id" placeholder="请选择处方" style="width: 150px;"
          @change="handleChange($event, 'prescription')">
          <el-option v-for="item in prescriptionList" :key="item.S_OP_ID" :label="item.S_OP_IO_Type_Name"
            :value="item.S_OP_ID" />
        </el-select>
      </p>
      <p><strong>直径：</strong>
        <el-select :disabled="!model.CHPS_OP_ALL_Id" size="mini" v-model="model.CHPLensDia" placeholder="请选择直径"
          style="width: 150px;" @change="handleChange($event, 'lensDia')">
          <el-option v-for="item in diameterSelectOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
      <p><strong>通道：</strong>
        <el-select :disabled="!model.CHPS_OP_ALL_Id" size="mini" v-model="model.CHPLensChannelLength"
          placeholder="请选择通道" style="width: 150px;" @change="handleChange($event, 'lensChannelLength')">
          <el-option v-for="item in channelSelectOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
    </div>
    <el-button slot="reference" type="text">{{ text || '关联处方' }}</el-button>
  </el-popover>
</template>
<script>
import { eye2SelectOptions, diameterSelectOptions, channelSelectOptions } from '../data/select-options';
import { getPrescriptionListApi, updateCartProductApi, updateCartProductLensDiameterApi, updateCartProductLensChannelApi } from '../api'
export default {
  name: 'RelatedPrescriptionPopover',
  inject: ['chooseId'],
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      text: '',
      eye2SelectOptions,
      diameterSelectOptions,
      channelSelectOptions,
      show: false,
      prescriptionList: [],
    }
  },
  created() {
    this.getPrescriptionList();
  },
  methods: {
    // 获取处方列表
    async getPrescriptionList() {
      if (!this.chooseId) return;
      const { data } = await getPrescriptionListApi(this.chooseId);
      if (data?.GetListResult?.length > 0) {
        const list = data.GetListResult.map(item => {
          const data = item.S_OP_Json.replace(/\*\*\*/g, '"');
          const S_OPData = JSON.parse(data);
          const typeObj = {
            '0': '框架远用',
            '2': '框架近用',
            '7': '角膜接触镜'
          };
          return {
            S_OP_ID: item.S_OP_ID,
            ...S_OPData,
            S_OP_IO_Type_Name: typeObj[S_OPData.S_OP_IO_Type]
          }
        });
        this.prescriptionList = list;
        // this.prescriptionSelectOptions = list.map(item => ({
        //   label: item.S_OP_IO_Type_Name,
        //   value: item.S_OP_ID
        // }));
      }
    },

    // 改变更新
    async handleChange(e, type) {
      try {
        // 眼别
        if (type === 'eye') {
          await updateCartProductApi(this.model);
        }
        // 处方
        if (type === 'prescription') {
          const { data } = await updateCartProductApi(this.model);
          if (data?.UpdateResult === 0) {
            const msg = `【${this.model.ProductRelation.ShopProduct.ProductName}】-${data?.msg}`
            this.$message.error(msg);
            this.model.CHPS_OP_ALL_Id = '';
          }
        }
        // 直径
        if (type === 'lensDia') {
          const { data } = await updateCartProductLensDiameterApi({
            ChooseProductId: this.model.ChooseProductId,
            CHPS_OP_ALL_Id: this.model.CHPS_OP_ALL_Id,
            CHPLeftRightEyes: this.model.CHPLeftRightEyes,
            SetLensDia: this.model.SetLensDia,
          });
        }
        // 管道
        if (type === 'lensChannelLength') {
          const { data } = await updateCartProductLensChannelApi({
            ChooseProductId: this.model.ChooseProductId,
            CHPS_OP_ALL_Id: this.model.CHPS_OP_ALL_Id,
            CHPLeftRightEyes: this.model.CHPLeftRightEyes,
            SetLensChannelLength: this.model.CHPLensChannelLength,

          })
        }
        this.$emit('success', this.model);
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
<style scoped lang="scss">
.medication-info {
  p {
    margin: 10px 0;

    strong {
      width: 70px;
      display: inline-block;
    }
  }

  .btn-wrapper {
    display: flex;
    justify-content: flex-end;
  }
}
</style>